import { useState } from "react"

export const useRecoveryForms = ({ schema, fields }: { schema: any, fields: any }) => {
    const [isLoading, setIsLoading] = useState(false);

    const [values, setValues] = useState<{ [key: string]: string | number }>(fields);
    const [errors, setErrors] = useState<{ [key: string]: string }>({});

    const validateField = async (id: string, value: string) => {
        try {
            await schema.validateAt(id, { [id]: value });
            setErrors((prevState) => ({ ...prevState, [id]: '' }));
            return { valid: true };
        } catch (validationError) {
            setErrors((prevState) => ({ ...prevState, [id]: validationError.message }));
            return { valid: false };
        }
    }

    const handleChange = async ({ target }: { target: HTMLInputElement | HTMLSelectElement }) => {
        const { id, value } = target;
        setValues({ ...values, [id]: value });
        validateField(id, value);
    }

    const handleCheck = ({ target }: { target: HTMLInputElement }) => {
        const { id, checked } = target;
        setValues({ ...values, [id]: checked ? 1 : 0 });
        if (checked) setErrors((prevState) => ({ ...prevState, [id]: '' }));
    }

    const onSubmit = async (callback?: () => void) => {
        setIsLoading(true);
        let thereIsError = false;
        for (const key in values) {
            if (typeof values[key] === 'number') continue;

            const { valid } = await validateField(key, `${values[key]}`);
            if (!valid) thereIsError = true;
        }
        if (!thereIsError) await callback?.();
        setIsLoading(false);
    }

    return {
        isLoading,
        errors,
        setErrors,
        values,
        handleChange,
        handleCheck,
        onSubmit,
    }
}